<template>
    <div class="article_note">
        <div class="image-with-descriptions">
            <img
                v-if="options.image"
                class="article_note__image"
                :src="$i18n.locale + '/images/' + options.image"
            />
            <template
                v-for="(description, idx_description) in options.descriptions"
            >
                <span
                    v-if="options.image"
                    class="image-with-descriptions__description"
                    :class="[
                        'image-with-descriptions__' +
                            description.position +
                            '-' +
                            description.orientation,
                        (options.color && options.color) || `text-white`,
                        (options.fontSize && options.fontSize) || `text-sm`,
                    ]"
                    v-html="description.text"
                    :key="idx_description"
                ></span>
            </template>
        </div>

        <span
            class="article_note__VerticalContent"
            :class="[
                (options.fontSize && options.fontSize.verticalcontent) ||
                    `text-base`,
                (options.color && options.color.verticalcontent) ||
                    `text-cornflower_blue`,
                (options.margin && options.margin.verticalcontent) ||
                    `-ml-20 mt-24`,
            ]"
            v-if="options.verticalcontent"
            v-html="options.verticalcontent"
        ></span>

        <h3
            class="article_note__title"
            :class="[
                (options.fontSize && options.fontSize.title) || `text-base`,
                (options.color && options.color.title) || `text-flamingo`,
            ]"
            v-if="options.title"
            v-html="options.title"
        ></h3>

        <p
            class="article_note__content"
            :class="[
                (options.fontSize && options.fontSize.content) || `text-base`,
                (options.color && options.color.content) || `text-flamingo`,
            ]"
            v-if="options.content"
            v-html="options.content"
        ></p>

        <div class="image-with-descriptions">
            <img
                v-if="options.imageBottom"
                class="article_note__image"
                :src="$i18n.locale + '/images/' + options.imageBottom"
            />
            <template
                v-for="(description, idx_description) in options.descriptions"
            >
                <span
                    v-if="options.imageBottom"
                    class="image-with-descriptions__description"
                    :class="[
                        'image-with-descriptions__' +
                            description.position +
                            '-' +
                            description.orientation,
                        (options.color && options.color) || `text-white`,
                        (options.fontSize && options.fontSize) || `text-sm`,
                    ]"
                    v-html="description.text"
                    :key="idx_description"
                ></span>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "ArticleNote",
    props: {
        options: null,
    },
};
</script>

<style lang="scss" scoped>
.article_note {
    @apply my-5 overflow-auto;

    &__image {
        @apply relative block w-3/4 m-auto;
    }

    &__VerticalContent {
        @apply absolute transform -rotate-90 font-bold origin-bottom;
    }
    &__title {
        @apply ml-14 mt-5;
    }
    &__content {
        @apply ml-14;
    }
}
.image-with-descriptions {
    @apply relative block w-full;

    &__image {
        @apply relative block w-full;
    }
    &__image300 {
        @apply relative block w-full;
        min-height: 300px;
    }
    &__image500 {
        @apply relative block w-full;
        min-height: 500px;
    }
    &__backgroungImageNewChapter {
        @apply relative w-full;
        height: 100vh;
        background-position: center;
        background-size: cover;
        object-fit: cover;
    }

    &__description {
        @apply absolute  top-0 left-0;
    }

    &__top {
        &-left {
            &-horizontal {
                @apply top-1 left-1 bottom-auto right-auto transform rotate-0 text-white text-left origin-top-left;
            }

            &-vertical {
                @apply top-1 left-1 bottom-auto right-auto transform -rotate-90 text-white text-left origin-top-right -translate-x-full mt-7;
            }
        }

        &-right {
            &-horizontal {
                @apply top-1 right-10 bottom-auto left-auto transform rotate-0 text-white text-right  origin-top-right;
            }

            &-vertical {
                @apply text-white top-1 right-20 sm:right-28 md:right-28 lg:right-16 bottom-auto left-auto transform -rotate-90 text-white text-right  origin-bottom-right;
            }
        }
    }

    &__bottom {
        &-left {
            &-horizontal {
                @apply bottom-1 left-20 top-auto right-auto transform rotate-0 text-white text-left origin-top-left;
            }

            &-vertical {
                @apply bottom-1 left-1 top-auto right-auto transform -rotate-90 text-white text-left origin-top-left;
            }
        }

        &-right {
            &-horizontal {
                @apply bottom-1 right-1 top-auto left-auto transform rotate-0 text-white text-right origin-top-left;
            }

            &-vertical {
                @apply bottom-1 right-16 top-auto left-auto transform -rotate-90 text-white text-right origin-bottom-left translate-x-full mb-7;
            }
        }
    }
}
</style>
